export const bim = {
  addBim: "Adicionar BIM",
  progressHelp:
    "Os arquivos devem ser processados para visualização, este processo pode levar alguns minutos.",
};
